import { Stack } from "@mui/material";
import { ReactNode } from "react";
import VisiblyScrollableV2 from "@/app/features/shared/__to_be_integrated/ui/v2/VisiblyScrollable";
import SplitContent from "@/app/features/shared/split-content/ui/SplitContent";
import Section from "@/app/features/shared/snap-section/Section";
import { DetailsMenuAlignment } from "@/app/features/shared/detail-section/types/types";

export function DetailSplitContentSectionContentFrame({ children }: { children: ReactNode }) {
    return (
        <VisiblyScrollableV2>
            <Stack
                className="w-full min-w-0 self-center"
                spacing={2}
            >
                {children}
            </Stack>
        </VisiblyScrollableV2>
    )
}

export function DetailSplitContentWrapperFrame({
    content,
    background,
    maxSplitPosition = 50,
    initialSplitPosition = 50,
    alignment,
    scrollDisabled = false,
    centerContentFromMiddle = false,
}: {
    content: ReactNode,
    background: ReactNode,
    maxSplitPosition?: number,
    initialSplitPosition?: number,
    alignment: DetailsMenuAlignment,
    scrollDisabled?: boolean,
    centerContentFromMiddle?: boolean,
}) {
    const contentStackSx = centerContentFromMiddle
        ? {
            my: "auto",
            pt: 1,
        }
        : {
            ...(scrollDisabled ? { flex: 1, minHeight: 0 } : {}),
            pt: 1,
        };

    return (
        <Section className="relative">
            <SplitContent
                variant="plain"
                alignment={alignment}
                maxSplitPosition={maxSplitPosition}
                initialSplitPosition={initialSplitPosition}
                backgroundMode="fill"
                content={
                    <VisiblyScrollableV2 scrollDisabled={scrollDisabled}>
                        <Stack
                            className={centerContentFromMiddle ? "flex flex-col flex-1 min-h-full w-full min-w-0" : undefined}
                        >
                            <Stack
                                className="w-full min-w-0 self-center"
                                sx={contentStackSx}
                                spacing={2}
                            >
                                {content}
                            </Stack>
                        </Stack>
                    </VisiblyScrollableV2>
                }
                background={background}
            />
        </Section>
    )
}
